// extracted by mini-css-extract-plugin
export default {"main_div":"Searchbar_main_div__78g1V","input_box":"Searchbar_input_box__dSmAo"};